import {
  DRAGGED_ATTRIBUTE,
  DRAGGED_ATTRIBUTE_DATA,
  DRAGGED_ATTRIBUTE_ID,
  DRAGGED_ATTRIBUTE_TYPE,
  DROPZONE_ATTRIBUTE,
  DROPZONE_ATTRIBUTE_DATA,
  DROPZONE_ATTRIBUTE_ID,
  DROPZONE_ATTRIBUTE_TYPE,
} from './DragAndDropOverlay'
import { DRAGGABLE_TYPE, type DROPZONE_TYPE } from './types'

export const getDragAndDropAttributes = (
  id: string,
  type: DRAGGABLE_TYPE | DROPZONE_TYPE,
  data: any,
  isOverlay: boolean = false
) => {
  if (type in DRAGGABLE_TYPE) {
    return {
      [DRAGGED_ATTRIBUTE]: !isOverlay,
      [DRAGGED_ATTRIBUTE_ID]: id,
      [DRAGGED_ATTRIBUTE_TYPE]: type,
      [DRAGGED_ATTRIBUTE_DATA]: JSON.stringify(data),
    }
  }
  return {
    [DROPZONE_ATTRIBUTE]: !isOverlay,
    [DROPZONE_ATTRIBUTE_ID]: id,
    [DROPZONE_ATTRIBUTE_TYPE]: type,
    [DROPZONE_ATTRIBUTE_DATA]: JSON.stringify(data),
  }
}
